import React, { useContext } from 'react';
import { FilterContext } from '../../context/FilterContext';
import { GetDataContext } from '../../context/GetDataContext';

//Components
import PollingCompanies from '../Menus/polling-companies';

// WIP
const PollsTable = () => {
    const {intData} = useContext(GetDataContext);
    const {filter} = useContext(FilterContext);

   const sortedDataInt = [...intData.data].reverse();
   console.log(sortedDataInt)
    return (
        <section className={'container poll-chart-list'}>
            <div className={'container_header'}>
                <h2 className={'section__title'}>{"ΠΙΝΑΚΑΣ ΔΗΜΟΣΚΟΠΗΣΕΩΝ"}</h2>
                <PollingCompanies />
            </div>
            <div className='table--content'>
                <table>
                    <thead>
                        <tr className='table--titles'>
                            <th>εταιρια</th>
                            <th>ημερομηνια</th>
                            <th>νεα δημοκρατια</th>
                            <th>συριζα-πσ</th>
                            <th>πασοκ/κιναλ</th>
                            <th>κκε</th>
                            <th>ελληνικη λυση</th>
                            <th>πλευση ελευθεριας</th>
                            <th>νικη</th>
                            <th>μερα25</th>
                            <th>νεα αριστερα</th>
                        </tr>
                    </thead>
                    <tbody>
                    {   
                        sortedDataInt.map((item, index) => {
                            if (filter.value !== 0) {
                                console.log(item)

                                if (filter.label === item.company.name) {
                                    return (
                                        <tr key={'a' + index}>
                                            <td className='company' key={Math.random() * Date.now() + '_' + index}>{item.company.name}</td>
                                            <td className='date' key={Math.random() * Date.now() + '_' + index}>{item.date.day}/{item.date.month}/{item.date.year}</td>
                                            <td className='party--neaDimokratia' key={Math.random() * Date.now() + '_' + index}>{item.neaDimokratia}</td>
                                            <td className='party--siriza' key={Math.random() * Date.now() + '_' + index}>{item.siriza}</td>
                                            <td className='party--kinalPasok' key={Math.random() * Date.now() + '_' + index}>{item.kinalPasok}</td>
                                            <td className='party--kke' key={Math.random() * Date.now() + '_' + index}>{item.kke}</td>
                                            <td className='party--ellinikiLisi' key={Math.random() * Date.now() + '_' + index}>{item.ellinikiLisi}</td>
                                            <td className='party--pleusi' key={Math.random() * Date.now() + '_' + index}>{item.plefsiEleftherias}</td>
                                            <td className='party--niki' key={Math.random() * Date.now() + '_' + index}>{item.niki}</td>
                                            <td className='party--mera25' key={Math.random() * Date.now() + '_' + index}>{item.mera25}</td>
                                            <td className='party--neaAristera' key={Math.random() * Date.now() + '_' + index}>{item.neaAristera}</td>

                                        </tr>
                                    );
                                }
                            }
                            else {
                                return(
                                    <tr key={'a' + index}>
                                        <td className='company' key={Math.random() * Date.now() + '_' + index}>{item.company.name}</td>
                                        <td className='date' key={Math.random() * Date.now() + '_' + index}>{item.date.day}/{item.date.month}/{item.date.year}</td>
                                        <td className='party--neaDimokratia' key={Math.random() * Date.now() + '_' + index}>{item.neaDimokratia}</td>
                                        <td className='party--siriza' key={Math.random() * Date.now() + '_' + index}>{item.siriza}</td>
                                        <td className='party--kinalPasok' key={Math.random() * Date.now() + '_' + index}>{item.kinalPasok}</td>
                                        <td className='party--kke' key={Math.random() * Date.now() + '_' + index}>{item.kke}</td>
                                        <td className='party--ellinikiLisi' key={Math.random() * Date.now() + '_' + index}>{item.ellinikiLisi}</td>
                                        <td className='party--pleusi' key={Math.random() * Date.now() + '_' + index}>{item.plefsiEleftherias}</td>
                                        <td className='party--niki' key={Math.random() * Date.now() + '_' + index}>{item.niki}</td>
                                        <td className='party--mera25' key={Math.random() * Date.now() + '_' + index}>{item.mera25}</td>
                                        <td className='party--neaAristera' key={Math.random() * Date.now() + '_' + index}>{item.neaAristera}</td>

                                    </tr>
                                );
                            } 
                        })
                    }
                    </tbody>
                </table>
            </div>
        </section>
    );
    

};

export default PollsTable;
